import * as Yup from "yup";

export const ticketUploadConstants = {
  HEADER_TXT: "Upload Ticket",
  SAVE_BTN_TXT: "Save",
  SAVE_REVIEW_BTN_TEXT: "Save & Review",
  SAVE_REVIEW_BTN_CLASS: "saveAndReviewButton",
  DISABLED_BTN_CLASS: "btnDisabled",
};

export const DrawerHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};

export const DrawerConstants = {
  DRAWER_PLACEMENT: "right",
  DRAWER_WIDTH: "50%",
  DRAWER_HEIGHT: "100vh",
  DRAWER_SIZE: "large",
};

export const uploadTicketDrawerFormValidation = Yup.object({
  customerName: Yup.string().required("required"),
  jobName: Yup.string().required("required"),
  orderId: Yup.string().required("required"),
  truckNumber: Yup.string().required("required"),
});

export const TicketNotificationMessages = {
  success: "Tickets Uploaded Successfully!",
  failure: "Failed to upload tickets!",
};
